// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"KDvIwP21","dim":"FZ6T68ty"};